// src/frontend_react/src/components/ui/Alert/Alert.js
import React from 'react';
import styles from './Alert.module.css';

const Alert = ({
  variant = 'info', 
  title,
  children, 
  className = '',
  icon, 
  showIcon = true, 
  onDismiss, 

  style,
  alignSelf,
  flexGrow,
  mt, mb, ml, mr,
  ...rest
}) => {
  const getIconForVariant = () => {
    if (icon) return icon; 
    if (!showIcon) return null;

    switch (variant) {
        case 'success': return <span className={`${styles.alertIcon} ${styles.iconPlaceholder}`}>✓</span>;
        case 'warning': return <span className={`${styles.alertIcon} ${styles.iconPlaceholder}`}>!</span>;
        case 'error':   return <span className={`${styles.alertIcon} ${styles.iconPlaceholder}`}>✕</span>;
        case 'info':
        default:        return <span className={`${styles.alertIcon} ${styles.iconPlaceholder}`}>ℹ</span>;
    }
  };

  const alertStyle = { ...style };
  const getSpacingValue = (v) => typeof v === 'number' ? `calc(var(--cipher-spacing-unit) * ${v})` : v;
  if (alignSelf) alertStyle.alignSelf = alignSelf;
  if (flexGrow) alertStyle.flexGrow = flexGrow;
  if (mt !== undefined) alertStyle.marginTop = getSpacingValue(mt);
  if (mb !== undefined) alertStyle.marginBottom = getSpacingValue(mb);
  if (ml !== undefined) alertStyle.marginLeft = getSpacingValue(ml);
  if (mr !== undefined) alertStyle.marginRight = getSpacingValue(mr);

  return (
    <div
      className={`${styles.alertBase} ${styles[variant]} ${className}`}
      role="alert"
      style={alertStyle}
      {...rest}
    >
      {(icon || showIcon) && (
        <div className={styles.iconContainer}>
          {getIconForVariant()}
        </div>
      )}
      <div className={styles.contentContainer}>
        {title && <h5 className={styles.alertTitle}>{title}</h5>}
        <div className={styles.alertMessage}>{children}</div>
      </div>
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          className={styles.dismissButton}
          aria-label="Dismiss alert"
        >
          ×
        </button>
      )}
    </div>
  );
};

export default Alert;